import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=79ace09a&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&id=79ace09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ace09a",
  null
  
)

export default component.exports